import React from 'react';
import './ForBusinesses.css'; 
import { Helmet } from 'react-helmet';

const ForBusinesses = () => {
  return (
    <section className="sustainable-business">
        <Helmet>
  <title>Sell on Verdure | For Businesses</title>
  <meta name="description" content="Are you an indie, sustainable brand? Apply to join Verdure and connect with conscious Gen Z shoppers." />
  <meta property="og:title" content="Sell on Verdure | For Businesses" />
  <meta property="og:description" content="Join our marketplace of ethical brands. Apply to be featured on Verdure today." />
</Helmet>

      <div className="business-container">
        <h2 className="business-title">For Sustainable Businesses</h2>
        
        <div className="business-content-wrapper">
          <div className="business-main-content">
            <p className="business-tagline">
              Explore a flexible, non-restrictive way to reach younger, conscious consumers
              looking for affordable, eco-friendly products.
            </p> 

            <h3 className="business-tools-heading">Our platform will have various tools to:</h3>

            <ul className="business-features-list">
              <li className="business-feature-item">
                <div className="business-feature-number">1</div>
                <div className="business-feature-text">
                  <p>Seamlessly manage and fulfill your own orders using your preferred shipping methods.</p>
                </div>
              </li>
              <li className="business-feature-item">
                <div className="business-feature-number">2</div>
                <div className="business-feature-text">
                  <p>Set prices, including customized shipping rates.</p>
                </div>
              </li>
              <li className="business-feature-item">
                <div className="business-feature-number">3</div>
                <div className="business-feature-text">
                  <p>Sync products, orders, and more with an alternate platform like Shopify.</p>
                </div>
              </li>
              <li className="business-feature-item">
                <div className="business-feature-number">4</div>
                <div className="business-feature-text">
                  <p>Get real time updates when someone purchases a product from your store.</p>
                </div>
              </li>
              <li className="business-feature-item">
                <div className="business-feature-number">5</div>
                <div className="business-feature-text">
                  <p>Showcase sustainability initiatives and your brand's story.</p>
                </div>
              </li>
            </ul>

            <div className="business-commission-box">
              <div className="business-commission-badge">Only 3%</div>
              <div className="business-commission-info">
                <p className="business-commission-heading">Minimal Commission</p>
                <p className="business-commission-details">
                  Retain almost all revenue from purchases, with payouts at time of purchase.
                </p>
              </div>
            </div>
            
            <a href="/account/registerbusiness" className="business-cta-button">
              Become a Partner
            </a>
          </div>

          <div className="business-graphic">
            <div className="business-graphic-background"></div>
            <div className="business-illustration">
              <svg viewBox="0 0 300 300" className="business-svg">
                {/* Plant/Leaf with Shop Elements */}
                <circle cx="150" cy="150" r="120" fill="#f0f9f0" />
                
                {/* Store/Shop Building Base */}
                <rect x="110" y="130" width="80" height="80" rx="5" fill="#4CAF50" />
                <rect x="130" y="180" width="40" height="30" fill="#388E3C" />
                <rect x="140" y="180" width="20" height="30" fill="#2E7D32" />
                
                {/* Plant/Growth Elements */}
                <path d="M150,60 Q180,90 150,120 Q120,150 150,180 Q180,150 210,120 Q180,90 150,60" fill="#66BB6A" stroke="#4CAF50" strokeWidth="2" />
                <path d="M90,120 Q120,90 150,120 Q120,150 90,120" fill="#81C784" stroke="#4CAF50" strokeWidth="2" />
                
                {/* Money/Business Elements */}
                <circle cx="210" cy="100" r="25" fill="#DCE775" stroke="#4CAF50" strokeWidth="2" />
                <text x="205" y="105" fontSize="20" fontWeight="bold" fill="#388E3C">$</text>
                
                {/* Connect lines */}
                <path d="M150,120 L170,110 L210,100" fill="none" stroke="#4CAF50" strokeWidth="2" strokeDasharray="5,3" />
                <path d="M150,120 L130,110 L100,120" fill="none" stroke="#4CAF50" strokeWidth="2" strokeDasharray="5,3" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForBusinesses;